import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { API_BASE, getAuthHeader } from '../api/api';

const EditUserModal = ({ user, onClose }) => {
  const [newPassword, setNewPassword] = useState('');
  const [userCases, setUserCases] = useState([]);

  useEffect(() => {
    fetchUserCases();
  }, [user.username]);

  const fetchUserCases = async () => {
    try {
      const res = await axios.get(`${API_BASE}/admin/users/${user.username}/cases`, getAuthHeader());
      setUserCases(res.data.cases);
    } catch (err) {
      console.error(err);
    }
  };

  const handleUpdatePassword = async () => {
    if (!newPassword) return;
    try {
      await axios.put(`${API_BASE}/admin/users/update`, {
        username: user.username,
        newPassword: newPassword
      }, getAuthHeader());
      setNewPassword('');
    } catch (err) {
      alert("Password update failed");
    }
  };

  const toggleCaseEdit = async (caseId, currentStatus) => {
    try {
      await axios.put(`${API_BASE}/admin/cases/${caseId}/toggle-edit`, {
        is_editable: !currentStatus
      }, getAuthHeader());
      fetchUserCases();
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg shadow-xl w-[500px] p-6 relative max-h-[90vh] overflow-y-auto">
        <button onClick={onClose} className="absolute top-4 right-4 text-gray-400 hover:text-gray-600 text-2xl">×</button>
        
        <h2 className="text-xl font-bold mb-6">Manage User: {user.username}</h2>

        <div className="space-y-6">
          <div className="pb-4 border-b">
            <label className="block text-sm font-medium text-gray-700 mb-1">Update Password</label>
            <div className="flex gap-2">
              <input 
                type="password" 
                className="w-full border rounded-md p-2 outline-none focus:ring-2 focus:ring-blue-500" 
                placeholder="Enter new password"
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
              />
              <button 
                onClick={handleUpdatePassword}
                className="bg-blue-600 hover:bg-blue-700 text-white font-bold px-4 rounded-md transition-colors"
              >
                Save
              </button>
            </div>
          </div>

          <div>
            <h3 className="text-lg font-bold mb-3 text-gray-800">Assigned Cases</h3>
            {userCases.length === 0 ? (
              <p className="text-sm text-gray-500">No cases assigned to this user.</p>
            ) : (
              <div className="space-y-3">
                {userCases.map((c) => (
                  <div key={c._id} className="flex items-center justify-between p-3 border rounded bg-gray-50">
                    <div className="flex-1 pr-4">
                      <p className="font-semibold text-sm">{c.title}</p>
                      <p className="text-xs text-gray-500 truncate">{c.description}</p>
                    </div>
                    <div className="flex items-center gap-2">
                      <span className="text-xs font-semibold text-gray-600">Edit</span>
                      <button
                        onClick={() => toggleCaseEdit(c._id, c.is_editable)}
                        className={`w-10 h-5 flex items-center rounded-full p-1 transition-colors ${c.is_editable ? 'bg-blue-600' : 'bg-gray-300'}`}
                      >
                        <div className={`bg-white w-3 h-3 rounded-full shadow-md transform transition-transform ${c.is_editable ? 'translate-x-5' : ''}`} />
                      </button>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditUserModal;